import React, { useState, useEffect } from 'react';
import Layout from '@/components/Layout';
import axios from 'axios';
import { ExternalLink } from 'lucide-react';
import { toast } from 'sonner';

import { BACKEND_URL, API } from '../config';

const News = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNews();
  }, []);

  const loadNews = async () => {
    try {
      const response = await axios.get(`${API}/market/news?limit=50`, { withCredentials: true });
      setNews(response.data.news);
    } catch (error) {
      toast.error('Failed to load news');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-full">
          <div className="text-center"><div className="aegis-spinner mx-auto"></div><p className="text-[#A1A1AA] text-sm mt-3">Cargando...</p></div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="space-y-6" data-testid="news-page">
        <div>
          <h1 className="text-3xl font-bold text-white tracking-tight">Noticias Cripto</h1>
          <p className="text-[#A1A1AA] mt-1">Últimas noticias y novedades del mundo cripto</p>
        </div>

        <div className="grid grid-cols-1 gap-4">
          {news.map((item, idx) => (
            <a
              key={idx}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#121212] border border-[#27272A] rounded-sm p-6 hover:border-[#00D4FF] transition-colors block" data-testid={`news-article-${idx}`}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-white mb-2">{item.title}</h3>
                  <p className="text-[#A1A1AA] text-sm line-clamp-2 mb-3">{item.description}</p>
                  <div className="flex items-center gap-4 text-xs text-[#52525B]">
                    <span>{item.source}</span>
                    <span>•</span>
                    <span>{new Date(item.published_at).toLocaleDateString()}</span>
                  </div>
                </div>
                <ExternalLink size={20} className="text-[#A1A1AA] ml-4 flex-shrink-0" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default News;